"use client";

/**
 * This file serves as a redirect to maintain backward compatibility
 * The actual implementation has been modularized and moved to src/components/MobileMenu/
 */

import MobileMenu from '@/components/MobileMenu';

export default MobileMenu; 